import React from "react";
import { Box, Container } from "@mui/material";

const ConsistentContainer = ({ children, bgcolor, ...props }) => (
  <Box sx={{ backgroundColor: bgcolor }}>
    <Container
      maxWidth="lg"
      sx={{
        px: { xs: 2, sm: 3 },
        ...props.sx,
      }}
    >
      {children}
    </Container>
  </Box>
);

export default ConsistentContainer;
